import { render } from "./exposure-item.vue?vue&type=template&id=18b52dda&ts=true"
import script from "./exposure-item.ts?vue&type=script&lang=ts&external"
export * from "./exposure-item.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__